import {
  Reflection,
  ReflectionData,
  ReflectionTimeRange
} from "@/entities/reflection";
import dayjs from "dayjs";

type ReflectionDataWithTimeRange = Omit<ReflectionData, "timeRange"> & {
  timeRange: ReflectionTimeRange;
};

export type ReflectionWithTimeRange = Omit<Reflection, "data"> & {
  data: ReflectionDataWithTimeRange;
};

export function fillMissingTimeRange(
  reflection: Reflection | ReflectionWithTimeRange
): ReflectionWithTimeRange {
  if (reflection.data.timeRange) {
    return reflection as ReflectionWithTimeRange;
  }

  const datePart = reflection.data.uid.slice(0, 10); // YYYY-MM-DD 部分だけ抜き取る
  const start = dayjs(datePart).startOf("day").unix();
  const end = dayjs(datePart).endOf("day").unix();

  const timeRange = {
    start,
    end
  };

  return {
    ...reflection,
    data: {
      ...reflection.data,
      timeRange
    }
  };
}
